import React from 'react';
import { Collapsible, TooltipList } from 'ion-lib';
import i18next from 'i18next';
import { Card } from 'react-bootstrap';

const Leistungen = ({
  deck,
  leistungenListe,
}) => (
  <Card.Body className="d-flex flex-column produktvergleich__leistungen">
    <TooltipList
      listType="keine"
      listElements={leistungenListe(
        deck,
        'andereLeistungen',
      )}
    />
    <TooltipList
      listElements={leistungenListe(
        deck,
        'leistungen',
      )}
    />
    <TooltipList
      listType="cross"
      listElements={leistungenListe(
        deck,
        'keineLeistungen',
      )}
    />
    <TooltipList
      listType="arrow"
      className="mt-3"
      listElements={leistungenListe(
        deck,
        'zusatzLeistungen',
      )}
    />

    {(leistungenListe(deck, 'leistungenDetail').length > 0
        || leistungenListe(deck, 'keineLeistungenDetail').length > 0)
      && (
        <Collapsible
          textOpen={i18next.t('produktvergleich.mehrleistungen')}
          textClose={i18next.t('produktvergleich.wenigerleistungen')}
          // position={trEnv.istOESA ? 'top' : 'bottom'}
          name={`${deck.label.value.toLowerCase()}-leistungen`}
        >
          <TooltipList
            listElements={leistungenListe(
              deck,
              'leistungenDetail',
            )}
          />
          <TooltipList
            listType="cross"
            listElements={leistungenListe(
              deck,
              'keineLeistungenDetail',
            )}
          />
        </Collapsible>
      )}
    {i18next.t('produktvergleich.links.leistungsuebersicht') !== ''
      && <p dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.links.leistungsuebersicht') }} />}
  </Card.Body>
);

export default React.memo(Leistungen);
